import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage } from "react-intl";
export const LysaManualReviewRejected = ({ poaStatus }) => {
    return (React.createElement("span", null, poaStatus.manualRejectReasons.length && (React.createElement("ul", { className: "snackbar-wrapper" }, poaStatus.manualRejectReasons.map((reason) => {
        if (reason === "POA_CHECK_UNSUPPORTED_DOCUMENT") {
            return (React.createElement("li", { key: reason },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement(FormattedMessage, { id: "onfido.status.poa.check.unsupported_document" }))));
        }
        if (reason === "POA_CHECK_INSUFFICIENT_IMAGE_QUALITY") {
            return (React.createElement("li", { key: reason },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement(FormattedMessage, { id: "onfido.status.poa.check.insufficient_image_quality" }))));
        }
        if (reason === "POA_CHECK_FIRST_NAME_MISMATCH") {
            return (React.createElement("li", { key: reason },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement(FormattedMessage, { id: "onfido.status.poa.lysa.check.first_name_mismatch" }))));
        }
        if (reason === "POA_CHECK_LAST_NAME_MISMATCH") {
            return (React.createElement("li", { key: reason },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement(FormattedMessage, { id: "onfido.status.poa.lysa.check.last_name_mismatch" }))));
        }
        if (reason === "POA_CHECK_EXPIRED_DOCUMENT") {
            return (React.createElement("li", { key: reason },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement(FormattedMessage, { id: "onfido.status.poa.lysa.check.expired_document" }))));
        }
        if (reason === "POA_CHECK_ADDRESS_MISMATCH") {
            return (React.createElement("li", { key: reason },
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
                    React.createElement(FormattedMessage, { id: "onfido.status.poa.check.address_mismatch" }))));
        }
        return null;
    })))));
};
